// Per-device flag marking a brand-new signup that must finish onboarding on a
// desktop. Set at signup time (email register success, or a Google new-account
// return with ?new=1), read by the app-wide mobile gate in AdminApp, and cleared
// on logout. It lives only on the device that signed up — a desktop never has
// it, so desktop is never gated; logins never set it, so existing users are free.
const KEY = 'aerochat_fresh_signup';

export function markFreshSignup() {
  try { localStorage.setItem(KEY, '1'); } catch { /* ignore (private mode, etc.) */ }
}

export function isFreshSignup() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function clearFreshSignup() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
